<template>
  <div id="app">
    <div class="header">
      <div class="logo">
        <div class="logoImg" @click="goWork">
          <!-- <router-link to="/"> -->
            <img src="./views/img/logo.png" alt="" />
          <!-- </router-link> -->
        </div>
      </div>
      <a-button
        class="work--next"
        ghost
        v-if="user && !user.temporary"
        @click="goWork"
        type="primary"
        >进入工作台</a-button
      >
      <div v-if="user && !user.temporary" class="user">
        <img :src="wuweiImage" alt="" />
        <a-dropdown v-model="visible">
          <span class="name"
            >{{ user.nickname }} <a-icon class="icon" :type="foldType"
          /></span>
          <a-menu slot="overlay" @click="handleMenuClick">
            <a-menu-item key="log">更新日志</a-menu-item>
            <a-menu-item key="personalCenter">个人中心</a-menu-item>
            <a-menu-item v-if="showEntrance" key="goComponents">进入组件库</a-menu-item>
            <a-menu-item key="logout">退出登录</a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
      <a-button
        v-else
        type="primary"
        @click="onLogin"
        class="login"
        size="small"
        >登录</a-button
      >
    </div>
    <nlp></nlp>

    <a-config-provider :locale="locale">
      <router-view class="body__wrapper" />
    </a-config-provider>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { stringify } from 'query-string'
import nlp from './views/components/nlp/index.vue'
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
export default {
  data () {
    return {
      visible: false,
      locale: zhCN,
      showEntrance: false,
      wuweiImage: null
    }
  },
  components: {
    nlp
  },
  created () {
    var string = JSON.parse(localStorage.getItem('wuweiLogInfo')).avatar
    var str = string.substr(0, 1)
    if (str === '[') {
      this.wuweiImage = JSON.parse(string)[0].imageInfo
    } else {
      this.wuweiImage = string
    }
  },
  computed: {
    ...mapState('editor', ['user']),
    foldType () {
      return this.visible ? 'right' : 'down'
    }
  },
  methods: {
    ...mapActions('editor', ['setUser']),
    handleMenuClick (payload) {
      switch (payload.key) {
        case 'logout':
          this.$post('/flow/api/5df882117ea6f7487d54fd27').then(data => {
            this.setUser({
              temporary: true
            })
            window.location.href = `${process.env.LOGIN_URL}?${stringify({
              url: window.location.href,
              ...this.$route.query
            })}`
            // if (this.$route.path !== '/') {
            //   this.$router.push('/')
            // } else {
            //   this.$event.$emit('signout')
            // }
          })
          this.$storage.set('wuweiLogIn', false)
          this.visible = false
          break
        case 'log':
          this.$router.push('/log')
          break
        case 'personalCenter':
          window.location.href = process.env.PERSONAL_URL
          break
      }
      if (payload.key === 'goComponents') {
        this.$router.push('/components')
        // this.$router.push({
        //     path: '/components',
        //     query: {
        //       project_id: this.$route.query.project_id
        //     }
        //   })
      }
      // this.$storage.set('wuweiLogIn', false)
      this.visible = false
    },
    onLogin () {
      let type = ''
      if (this.$route.name.indexOf('editor') !== -1) {
        type = 'editor'
      } else if (this.$route.name.indexOf('version') !== -1) {
        type = 'version'
      }
      window.location.href = `${process.env.LOGIN_URL}?${stringify({
        url: window.location.href,
        ...this.$route.query,
        type
      })}`
    },
    goWork () {
      if (this.$route.query.project_id) {
        window.location.href = `${process.env.WORK_URL}?project_id=${
          this.$route.query.project_id
        }&url=${encodeURIComponent(window.location.href)}`
      } else {
        window.location.href = `${
          process.env.WORK_URL
        }?url=${encodeURIComponent(window.location.href)}`
      }
    }
  },
  beforeCreate () {
    this.$post('/flow/api/5df8967d7bad7f48a76d3de8').then(data => {
      if (!data.user.avatar) {
        data.user.avatar =
          'https://hexyun.oss-cn-beijing.aliyuncs.com/resource/5de87ea7ace38460a1ed2dcb/4e1a204896de127ecf25f434d892f158.png'
      }
      this.$storage.set('wuweiLogIn', !data.user.temporary)
      this.$storage.set('wuweiLogInfo', data.user)
      this.setUser(data.user)
      var rights = data.user.user.authSign
      // && ['REUSE_COMPONENT_ENTER']
      this.showEntrance = rights.includes('REUSE_COMPONENT_ENTER')
      console.log('right', this.showEntrance)
      if (data.user.temporary) {
        window.location.href = `${process.env.LOGIN_URL}?${stringify({
          url: window.location.href,
          ...this.$route.query
        })}`
      }
    })
  },
  mounted () {
    this.$event.$on('logIn', () => {
      this.onLogin()
    })
  },
  beforeDestroy () {
    this.$event.$off('logIn')
  }
}
</script>

<style lang="less">
* {
  &::-webkit-scrollbar {
    width: 4px;
    height: 4px;
  }
  &::-webkit-scrollbar-track {
    border-radius: 2px;
    background: rgba(50, 50, 50, 0.1);
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 2px;
    background: rgba(50, 50, 50, 0.2);
  }
}
.ant-spin-container {
  height: 100%;
}
.ant-spin-spinning {
  top: 50%;
  transform: translateY(-50%);
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: rgba(247, 247, 247, 1);
  height: 100%;
  display: flex;
  flex-flow: column;
  .header {
    flex: none;
    height: 64px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.15);
    display: flex;
    align-items: center;
    justify-content: flex-end;
    z-index: 1;
    .logo {
      position: absolute;
      left: 0;
      top: 0;
      height: 34px;
      display: flex;
      align-content: space-between;
      margin-top: 15px;
      .logoImg {
        cursor:pointer;
        height: 100%;
        margin: auto 20px auto 46px;
        a {
          height: 100%;
          display: block;
        }
        img {
          width: auto;
          height: 100%;
          border: none;
          border-radius: 0;
        }
      }
      .title {
        font-size: 16px;
        font-weight: bold;
        margin: auto;
      }
    }
    img {
      width: 40px;
      height: 40px;
      border-radius: 100%;
    }
    .user {
      padding-right: 20px;
      img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        margin-right: 8px;
      }
      .icon {
        margin-left: 12px;
      }
    }
    .login {
      margin-right: 20px;
    }
  }
  .body__wrapper {
    flex: none;
    height: calc(100vh - 64px);
  }
}
ul,
li {
  list-style: none;
  margin: 0;
  padding: 0;
}

[draggable] {
  img {
    user-select: none;
  }
  user-select: none;
}
.work--next {
  margin-right: 24px;
}

.draggable__wrapper {
  & > .sortable-chosen.ghost {
    padding: 0 18px;
  }
}
.draggable {
  & > .sortable-chosen.ghost {
    padding: 0;
    &.active{
    }
  }
}

.qr__box {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
}
</style>
